import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { Button } from 'gatsby-theme-material-ui';
import Feature from '../../../shared/Feature/Feature';
import Section from '../../../shared/Section/Section';
import LocationLabel from '../../../shared/AnimatedLabel/LocationLabel';
import ModalBlock from '../../../shared/ModalBlock/ModalBlock';
import ProgramRequestModal from '../../../shared/Modals/ProgramRequestModal';
import { capitalizeText } from '../../../helpers/lib';
import styles from './dsStyles';

const colorThemes = {
  dark: {
    mainColor: 'kit.text.mainInverse',
    titleColor: 'kit.text.mainInverse',
    titleSize: '72px',
    iconColor: 'kit.text.accent',
    listColor: 'rgba(41, 237, 255, 0.8)',
    typeTextColor: 'rgba(255, 255, 255, 0.5)',
    weeksTextColor: 'kit.background.white',
    weeksPosition: {
      left: '7%',
      top: '45%',
    },
    buttonVariant: 'inverse',
  },
  default: {
    mainColor: 'kit.background.black',
    titleColor: 'kit.background.black',
    iconColor: 'kit.background.black',
    listColor: 'kit.text.secondary',
    weeksTextColor: 'kit.background.white',
    weeksPosition: {
      left: '7%',
      top: '45%',
    },
  },
  main: {
    mainColor: 'kit.text.main',
    titleColor: 'kit.text.h',
    iconColor: 'kit.background.main',
    listColor: 'rgba(15, 15, 15, 0.8)',
    weeksTextColor: 'kit.background.white',
    weeksPosition: {
      left: '7%',
      top: '45%',
    },
  },
  lightPurple: {
    mainColor: 'kit.text.main',
    titleColor: 'kit.text.h',
    iconColor: 'kit.background.main',
    listColor: 'rgba(15, 15, 15, 0.8)',
    weeksTextColor: 'kit.text.h',
    weeksPosition: {
      left: '0%',
      top: '30%',
    },
  },
  middlePurple: {
    mainColor: 'kit.text.main',
    titleColor: 'kit.text.main',
    iconColor: 'kit.background.main',
    listColor: 'rgba(15, 15, 15, 0.8)',
    weeksTextColor: 'kit.text.h',
    weeksPosition: {
      left: '0%',
      top: '30%',
    },
  },
};

const formData = {
  title: 'Оставьте ваши контакты для связи',
  subtitle: 'Получить консультацию',
  sentContent: {
    title: 'Успешно записаны на консультацию!',
    message: 'Скоро с вами свяжется куратор',
  },
};

function GreetingsDS({
  theme = 'dark',
  location,
  type,
  title,
  features,
  bg,
  labelTheme,
  requestLeadData,
  ymEvents = {},
  isPrecourse,
  isProgram = true,
}) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const isBelowMd = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const [isRequestOpen, setIsRequestOpen] = useState(false);

  const colorTheme = colorThemes[theme] || colorThemes.main;
  const modalTitle = capitalizeText(
    Array.isArray(title) ? title.join('') : title,
  );

  return (
    <Section
      bg={bg}
      position={'right'}
      withoutBg={!bg}
      theme={theme || 'dark'}
      customStyles={{
        pt: { xs: '32px !important', lg: '56px !important' },
        pb: { xs: '40px !important', lg: '73px !important' },
        borderRadius: { xs: '0px 0px 24px 24px', lg: 0 },
        overflow: 'hidden',
        mt: '-1px',
        ml: '-1px',
        backgroundColor: 'white',
      }}
      wrapperStyles={{ backgroundColor: 'kit.background.gray' }}
    >
      <Grid container color={colorTheme.mainColor}>
        <Grid item xs={12} md={6}>
          <Box sx={styles.top}>
            <LocationLabel
              theme={labelTheme}
              type={location.type}
              title={location.title}
            />
            <Typography variant="desktopP2" sx={styles.type}>
              {type}
            </Typography>
          </Box>
          <Typography
            component="h1"
            variant="desktopHXXL"
            sx={{ ...styles.title, color: colorTheme.titleColor }}
          >
            {Array.isArray(title)
              ? title.map((item, index) => (
                  <Typography
                    key={index}
                    component="span"
                    sx={{ display: 'block' }}
                  >
                    {item}
                  </Typography>
                ))
              : title}
          </Typography>
          {features && (
            <Box sx={styles.features} component="ul">
              {features.map((feature, index) => (
                <Box key={index} component="li" sx={styles.featureItem}>
                  <Feature {...feature} theme={theme} />
                </Box>
              ))}
            </Box>
          )}
        </Grid>
        <Grid item xs={12} sx={{ mt: !isProgram && !isBelowMd ? -5 : 0 }}>
          {isProgram && (
            <Box sx={styles.buttonsBlock}>
              {!isPrecourse && (
                <Button
                  variant="kitPrimary"
                  size={isSm ? 'large' : 'medium'}
                  component="span"
                  sx={styles.button}
                  onClick={() => {
                    setIsRequestOpen(true);
                  }}
                >
                  Записаться
                </Button>
              )}
            </Box>
          )}
        </Grid>
      </Grid>

      <ModalBlock
        isOpen={isRequestOpen}
        handleClose={() => setIsRequestOpen(false)}
      >
        <ProgramRequestModal
          extraLeadData={requestLeadData}
          formData={{ title: modalTitle, subtitle: type }}
          ymSubmitEventTypes={[ymEvents.consultationFormSubmit]}
        />
      </ModalBlock>
    </Section>
  );
}

export default GreetingsDS;
